import { DataBean } from "../DataBean";

export class InventoryStore extends DataBean{


    public async getInventoryStoreList(id:any):Promise<any>
    {
        return this.getCustomService("QuickDataERPCore","java.util.List_getInventoryStoreList_Number",[id]);
    }
}